<template>
  <div :class="[containerClass, tabbed ? 'tabbed-container' : '']" class="overflow-hidden mb-6 renedian-white--background">
    <div v-if="!tabbed" class="d-flex justify-center align-center font-size-huge" :class="[colorClass + '--background', 'text-center', 'white--text', 'barlow-condensed-bold']">
      {{ year }}
    </div>
    <div class="white renedian-sand--background">
      <div class="d-flex flex-column white justify-center align-center">
        <!-- Rider Price -->
        <div class="rider-price-container d-flex flex-row justify-center pa-6 mt-6">
          <div class="d-flex flex-column flex-md-row justify-center align-center">
            <div class="d-flex flex-column">
              <div class="barlow-condensed-regular text-uppercase font-size-lg line-height-4">Rider Price</div>
              <div class="barlow-regular d-none d-md-block text-right text-uppercase font-size-xs">From</div>
            </div>
            <div class="d-flex flex-row align-center">
              <div class="d-block d-md-none barlow-regular text-right text-uppercase font-size-sm">From</div>
              <div :class="['ml-4', 'barlow-condensed-semibold', colorClass + '--text']" class="font-size-huge">
                {{ pricing.tour?.base | price }}
              </div>
              <div class="d-flex ml-2" style="height: 3rem; align-items: flex-end;">
                {{ currency }}
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row align-center justify-center px-4">
          <div :class="['barlow-bold', 'text-uppercase', colorClass + '--text', 'mr-4']" class="font-size-xs">Includes</div>
          <div class="d-flex flex-column">
            <div class="barlow-regular text-uppercase">
              <v-avatar size="30" class="mr-2">
                <img src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FMotorcycle.svg?alt=media&token=e0161813-f4bc-46af-a624-ddbab3569659" style="padding: 2px" alt="" />
              </v-avatar>
              {{ vehicleOptions[0]?.name || 'Standard Motorcycle' }}
            </div>
            <div class="barlow-regular text-uppercase d-flex flex-row align-center">
              <v-avatar size="30" class="mr-2">
                <img src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FShared.svg?alt=media&token=079653e3-cb05-4904-835f-28d0f7ccc94d" alt="" />
              </v-avatar>
              shared accomodations
            </div>
          </div>
        </div>
        <!-- Color Divider -->
        <div v-if="pricing.tour?.passenger > 0" :class="[colorClass + '--background', 'my-12', 'width-60']" style="height: 2px;"></div>
        <!-- Passenger Price -->
        <div v-if="pricing.tour?.passenger > 0" class="rider-price-container d-flex flex-row justify-center">
          <div class="d-flex flex-column flex-md-row justify-center align-center">
            <div class="d-flex flex-column">
              <div class="barlow-condensed-regular text-uppercase font-size-lg line-height-4">Passenger Price</div>
              <div class="barlow-regular d-none d-md-block text-right text-uppercase font-size-xs">From</div>
            </div>
            <div class="d-flex flex-row align-center">
              <div class="d-block d-md-none barlow-regular text-right text-uppercase font-size-sm">From</div>
              <div :class="['ml-4', 'barlow-condensed-semibold', colorClass + '--text']" class="font-size-huge">
                {{ pricing.tour?.passenger | price }}
              </div>
              <div class="d-flex ml-2" style="height: 3rem; align-items: flex-end;">
                {{ currency }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="pricing.tour?.passenger > 0">
          <div class="d-flex flex-column flex-md-row align-center justify-center pa-4">
            <div :class="['barlow-bold', 'text-uppercase', colorClass + '--text', 'mr-4']" class="font-size-xs">Includes</div>
            <div class="d-flex flex-column">
              <div v-if="hasSupportVehicle" class="barlow-regular text-uppercase d-flex flex-row align-center">
                <v-avatar size="30" class="mr-2">
                  <img src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FVan.svg?alt=media&token=918407c0-86b1-49b8-868e-bda830c40a42" style="padding: 2px" alt="" />
                </v-avatar>
                Passenger on bike or support vehicle
              </div>
              <div v-else class="barlow-regular text-uppercase d-flex flex-row align-center">
                <v-avatar size="30" class="mr-2">
                  <img src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FMotorcycle.svg?alt=media&token=e0161813-f4bc-46af-a624-ddbab3569659" style="padding: 2px" alt="" />
                </v-avatar>
                Passenger on bike
              </div>
              <div class="barlow-regular text-uppercase d-flex flex-row align-center">
                <v-avatar size="30" class="mr-2">
                  <img src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Ficons%2FShared.svg?alt=media&token=079653e3-cb05-4904-835f-28d0f7ccc94d" alt="" />
                </v-avatar>
                shared accomodations
              </div>
            </div>
          </div>
        </div>
        <!-- Color Divider -->
        <div :class="[colorClass + '--background', 'mt-12', 'width-100']" style="height: 2px;"></div>
        <!-- Accommodation Options Heading -->
        <div :class="['barlow-condensed-regular', 'text-uppercase', 'mb-2', 'text-center', colorClass + '--text']" class="font-size-lg py-1 line-height-4 py-2">Accommodation Options</div>
        <!-- Color Divider -->
        <div :class="[colorClass + '--background', 'mb-12', 'width-100']" style="height: 2px;"></div>
        <!-- Accommodation Options -->
        <div class="d-flex flex-row align-center">
          <v-icon>mdi-bed</v-icon>
          <div class="ml-4 barlow-regular text-uppercase">Single Room</div>
          <div :class="['ml-4', 'barlow-bold-italic', colorClass + '--text']">
            +{{ pricing.tour?.solo | price }} {{ currency }}
          </div>
        </div>

        <!-- Vehicle Options -->
        <div :class="[colorClass + '--background', 'mt-12', 'width-100']" style="height: 2px;"></div>
        <!-- Vehicle Options Heading -->
        <div :class="['barlow-condensed-regular', 'text-uppercase', 'my-2', 'text-center', colorClass + '--text']" class="font-size-lg py-1 line-height-4">Vehicle Options</div>
        <div class="ml-4 barlow-regular mb-3 px-2 mb-2">Don't see your preferred ride? Contact us - we may be able to find it for you!</div>
        <!-- Color Divider -->
        <div :class="[colorClass + '--background', 'width-100']" style="height: 2px;"></div>
        <div class="d-flex flex-column justify-center py-6 px-4">
          <div v-for="(vehicle, index) in vehicles" :key="'vehicle-' + index" class="d-flex flex-row align-center cursor-pointer" @click="$emit('vehicle-selected', vehicle)" style="transition: opacity 0.2s;" @mouseenter="$event.currentTarget.style.opacity = '0.7'" @mouseleave="$event.currentTarget.style.opacity = '1'">
            <img :src="$img(vehicle.images.thumbnail, 200)" :alt="`${vehicle.make} ${vehicle.model}`" loading="lazy" style="width: 80px; height: 52px; object-fit: contain; flex-shrink: 0;" />
            <div class="d-flex flex-column">
              <div class="ml-4 barlow-regular text-uppercase">{{ vehicle.make }} {{ vehicle.model }}</div>
              <div v-if="isCustomerBike(vehicle) || (vehicle.rate.supplement < 0)" class="ml-4 barlow-bold-italic" style="color: #2e7d32;">
                Credit: {{ Math.abs(vehicle.rate.supplement || 0) | price }} {{ currency }}
              </div>
              <div v-else-if="vehicle.rate.supplement == 0" :class="['ml-4', 'barlow-bold-italic', colorClass + '--text']">included</div>
              <div v-else :class="['ml-4', 'barlow-bold-italic', colorClass + '--text']">+{{ vehicle.rate.supplement | price }} {{ currency }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TourDetailsPrice',
  props: {
    year: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    template: {
      type: Object,
      required: true
    },
    tour: {
      type: Object,
      required: true
    },
    tabbed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    colorClass() {
      return this.color
    },
    containerClass() {
      if (this.color === 'renedian-burnt-orange') {
        return 'current-year-container'
      } else if (this.color === 'renedian-sand-grey') {
        return 'next-year-container'
      }
      return ''
    },
    pricing() {
      return this.tour?.pricing || {}
    },
    vehicles() {
      const vehicles = this.tour?.vehicles || []
      return Array.isArray(vehicles) ? [...vehicles].sort((a, b) => (a?.order || 0) - (b?.order || 0)) : []
    },
    vehicleOptions() {
      return this.vehicles.map(vehicle => ({
        name: vehicle.name || vehicle.model || 'Unknown Vehicle',
        price: vehicle.price || vehicle.upgrade || 0
      }))
    },
    hasSupportVehicle() {
      return this.template?.riding?.supportVehicle || false
    },
    currency() {
      return this.pricing?.currency || 'CAD'
    }
  },
  methods: {
    isCustomerBike(vehicle) {
      return vehicle.type === 'ownBike' || 
             (vehicle.make === 'Customer Bike' && vehicle.model === 'Discount')
    }
  },
  filters: {
    price(price) {
      if (price === undefined || price === null || isNaN(Number(price))) return price
      return '$' + Number(price).toLocaleString()
    }
  }
}
</script>

<style scoped>
.tabbed-container {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.current-year-container {
  border: 2px solid #b35438;
  border-radius: 30px;
}
.next-year-container {
  border: 2px solid #48622e;
  border-radius: 30px;
}
</style>
